module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/hero-mobile@2x.15234e9.jpg";